import React from 'react'

export const SaveIcon = ({
  fill = 'none',
  width = '20',
  height = '20',
  stroke = '#000000',
  strokeGradient = [],
  viewBox = '0 0 24 24'
}) => (
  <svg
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
  >
    {
      strokeGradient.length
        ? (
          <defs>
            <linearGradient
              id="gradient"
              x1="60%"
              x2="40%"
              y1="40%"
              y2="60%"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset="0%"
                stopColor={strokeGradient[0]}
              />
              <stop
                offset="100%"
                stopColor={strokeGradient[1]}
              />
            </linearGradient>
          </defs>
        ) : ''
    }

    <path
      d="M6 4C5.44772 4 5 4.44772 5 5V20.5C5 21.0523 5.44772 21.5 6 21.5C6.18852 21.5 6.37275 21.4462 6.53257 21.3457L12 17.933L17.4674 21.3457C17.6273 21.4462 17.8115 21.5 18 21.5C18.5523 21.5 19 21.0523 19 20.5V5C19 4.44772 18.5523 4 18 4H6Z"
      fill={fill}
      stroke={stroke === 'gradient' ? 'url(#gradient)' : stroke}
      strokeWidth="1.5"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
)
